import store from 'stores/store'

export type TransactionNotificationType = {
  type: 'success' | 'info' | 'error' | 'confirm'
  title: string
  description?: null | string
  txid?: string
  show: boolean
  id: number
}

export function notify(newNotification: {
  type?: 'success' | 'info' | 'error' | 'confirm'
  title: string
  description?: string
  txid?: string
  noMangoIdlEnrichment?: boolean
}) {
  const set = store.getState().set
  const notifications = store.getState().transactionNotifications
  const lastId = store.getState().transactionNotificationIdCounter
  const newId = lastId + 1

  const newNotif: TransactionNotificationType = {
    id: newId,
    type: 'success',
    show: true,
    description: null,
    ...newNotification,
  }

  const parsedNotif = !newNotification.noMangoIdlEnrichment
    ? enrichError(newNotif)
    : newNotif
  if (
    !parsedNotif.txid ||
    !notifications.find(
      (n) => n.txid == parsedNotif.txid && n.type == parsedNotif.type,
    )
  ) {
    set((state) => {
      state.transactionNotificationIdCounter = newId
      state.transactionNotifications = [...notifications, parsedNotif]
    })
  }
}

function enrichError(
  unparsedNotification: TransactionNotificationType,
): TransactionNotificationType {
  const notification = { ...unparsedNotification }
  return notification
}
